import Cookies from 'js-cookie';

export const getCookie = (name) => {
  return Cookies.get(name);
};

export const setCookie = (name, value, options) => {
  console.log('name, value, options --------->', name, value, options)
  return Cookies.set(name, value, options);
};

export const removeCookie = (name) => {
  return Cookies.remove(name);
};